<template>
    <section class="content pdf-content">
    <h4>{{ title }}</h4>
    <h6 v-if="subtitle">{{ subtitle }}</h6>
    <div style = "height: 100%">
        <iframe :src="'/static/pdf-js/web/viewer.html?file=' + pdfUrl +
        ($route.params.pageNumber ? `#page=${$route.params.pageNumber}` : '')"
        style="width: 100%; height: 80%; border: 1px solid #888"
        ></iframe>

        <!-- <embed :src="pdfUrl +
        ($route.params.pageNumber ? `#page=${$route.params.pageNumber}` : '')"
        style="width: 100%; height: 80%; border: 1px solid #888"/> -->
    <div class="footer">
        <span v-if="prev" style=""><a :href="prev">Prev</a></span>
        <router-link to="/">Contents</router-link>
        <span v-if="next" style=""><a :href="next">Next</a></span>
    </div>

    </div>
    </section>
</template>

<script>
export default {
  name: 'Page',
  props: {
    title: String,
    subtitle: String,
    pdfUrl: String,
    prev: String,
    next: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.signature {
  margin-top: 0px;
  transform: translateY(-20px);
}
</style>



// WEBPACK FOOTER //
// src/components/Pdf.vue